import { assert } from '@ember/debug'
import GravityAdapter from 'district-ui-client/adapters/gravity'
import type { Snapshot } from '@ember-data/legacy-compat/legacy-network-handler/snapshot'

/**
 * We GET this model via gravity school includes.
 */
export default class ContactDetailAdapter extends GravityAdapter {
  urlForUpdateRecord(id: string, modelName: string, snapshot: Snapshot<unknown>) {
    const schoolId = snapshot.adapterOptions?.schoolId
    assert('schoolId is required to PATCH contact-detail', typeof schoolId === 'string')

    const url = super.urlForUpdateRecord(id, modelName, snapshot) // api/v3/contact-details/:id

    // prepend with school id to make api/v3/schools/:school-id/contact-details/:id
    const scope = `schools/${schoolId}`
    const pathForModelName = super.pathForType(modelName) // eg contact-details
    return url.replace(pathForModelName, `${scope}/${pathForModelName}`) // /api/v3/schools/123/contact-details/456 - note: only replaces first occurrence
  }
}
